/**
 * 功能: 点击横版报告预览页面的目录按钮显示的内容, 分为章节目录、图表目录、名词解释和报告日志
 * 点击对应的一栏可以跳转到对应的位置
 */

<template lang="pug">
  div
    el-tabs(:stretch="true" v-model="choosePan")
      el-tab-pane(name="first" label="章节目录")
        el-tree(class="filter-tree"  :data="outlineWbs" node-key="_id" :default-expand-all="true"  :highlight-current="true" :expand-on-click-node="false"
            @node-click="handleNodeClick" ref="outlineTree")
              span.custom-tree-node(slot-scope="{node,data}" class="span-ellipsis" :title="data.name") {{data.wbs}} {{data.name}}
      el-tab-pane(name="second" label="图表目录")
        div(v-for="attchment in chartOutline" style='margin:0 0 20px')
          label(:key="attchment._id" @click="handleChangeSlide(attchment)")
            h3 {{attchment.explain}} {{attchment.title || ''}}
            div(style='width:100%;height:180px')
              img(:src="attchment.attachment.newhiImageUrl" style='width:100%;height:100%' v-if="attchment.attachment._class === 0" v-loading="isLoading")
              div.tablelook.previewtableLook(v-html="attchment.attachment.html" style='width:818px;height:100%' v-if="attchment.attachment._class === 1")
              drawSziePro(v-if="attchment.attachment._class === 2" :dialogData="attchment.attachment" style='width:100%;height:180px' :isActive="false")
          el-divider
      el-tab-pane(name="third" label="名词解释")
        div(v-for="(glossary,index) in glossaryArr")
          p.glossary(:key="index") {{glossary.noun}}:{{glossary.explanation}}
      el-tab-pane(name="fourth" label="报告日志")
        div(v-for="(log,index) in updateLog" :key="index")
          div(style='margin-bottom:10px')
            p 作者:{{log.author}}
            p 发布日期:{{log.pubDate | changeData}}
            p 描述:{{log.description}}
            //- p 文件地址:{{log.originalFile}}
</template>

<script>
import drawSziePro from '@/views/size/components/drawsizePro'
import apiImg from '@/apis/commuCore'
import { parseTime } from '@/javascripts/time'
export default {
  name: 'Aside',
  props: {
    glossaryArr: { type: Array, default: () => [] },
    chartOutline: { type: Array, default: () => [] },
    outlineWbs: { type: Array, default: () => [] },
    updateLog: { type: Array, default: () => [] }
  },
  components: {
    drawSziePro
  },
  watch: {
    chartOutline: {
      // 获取图表目录的图片
      handler: function (val) {
        for (let i = 0; i < val.length; i++) {
          if (val[i].attachment && val[i].attachment._class === 0) {
            apiImg.downloadFile(this.GLOBAL.uploadHost + 'illustration/downloadUrl?url=' + val[i].attachment.hiImageUrl).then(res => {
              this.chartOutline[i].attachment.newhiImageUrl = window.URL.createObjectURL(res)
            })
          }
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      choosePan: 'first',
      isLoading: true
    }
  },
  methods: {
    // 点击目录后跳转
    handleNodeClick (e) {
      if (e.slide.length) {
        this.$bus.$emit('clickOutline', e)
      }
    },
    // 点击图表目录跳转
    handleChangeSlide (attchment) {
      this.$bus.$emit('handleChangeSlide', attchment.slide)
    }
  },

  filters: {
    changeData: function (val) {
      if (!val) {
        return '暂无日期'
      }

      var date = new Date(val)
      return parseTime(date, '{y}-{m}-{d}')
    }
  }
}
</script>

<style scoped>
.el-tabs__active-bar{
  width: 65px !important;
}
.span-ellipsis{
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.glossary{
  text-indent: 2em;
  margin: 0 0 10px;
}
.tablelook{
  overflow: hidden;
  text-overflow:ellipsis;
  position: relative;
}
</style>

<style scoped>
.previewtableLook table{
  position: absolute;
  transform: scale(0.3,0.5);
  top: -68px;
  width: 818px;
  left: -270px;
}
</style>
